
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 323.97 323.97"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M315.062 175.001h-112.28c-4.907 0-8.907 4-8.907 8.906 0 2.499 1.062 4.75 2.718 6.374l79.062 79.062a8.92 8.92 0 006.533 2.845 8.894 8.894 0 007.405-3.938c19.438-22.563 31.938-51.219 34.189-82.75a6.932 6.932 0 00.187-1.594 8.902 8.902 0 00-8.907-8.905zM168.875 13.594c-4.907.03-8.875 4-8.875 8.906v124.781c0 4.938 3.968 8.938 8.875 8.938h124.813c4.907 0 8.906-4 8.906-8.938-4.407-71.811-61.876-129.28-133.719-133.687z"}}),_c('path',{attrs:{"d":"M237.469 262.063l-92.062-92.062c-1.562-1.594-2.499-3.813-2.499-6.219l-.033-130.032A8.869 8.869 0 00134 24.875C59.219 29.438 0 91.562 0 167.47c0 78.906 63.97 142.906 142.875 142.906 36 0 68.875-13.312 94-35.282a8.821 8.821 0 003.157-6.781 8.92 8.92 0 00-2.563-6.25z"}})])
          )
        }
      }
    